module Meevo.Plugins.AppointmentBook {
    export class MeevoBlockEditor implements angular.IDirective {
        restrict = "E";
        scope = true;
        require = '^form';
        templateUrl = "app/plugins/AppointmentBook/views/directives/BlockEditor.html";

        constructor(
            private $mdSidenav: any,
            private editorService: any,
            private $translate: angular.translate.ITranslateService,
            private actions: any) {
        }

        link: ng.IDirectiveLinkFn = (scope: any, element: JQuery, attrs: angular.IAttributes, form: any) => {
            var toggleSecondary = false;
            scope.toggle = false;
            scope.editorService = this.editorService;

            let handler = function()
            {
                if (toggleSecondary) {
                    scope.toggleRightInfo();
                    scope.toggle = false;
                }
            };
            angular.element(window).on('orientationchange', handler);

            scope.$on('$destroy', ()=> {
                angular.element(window).off('orientationchange', handler);
            });

            scope.save = () => {
                if (form.$valid) {
                    this.editorService.saveBlock();
                }
            }

            scope.$on("blockSaved", function () {
                scope.toggleRight();
            });

            scope.$on("cancelBlockSave", function () {
                scope.toggleRight();
            });

            scope.toggleRight = () => {
                this.$mdSidenav('blockEditor').close();
                this.actions.CheckForAdjustEditor();
                scope.toggle = false;
            };
            scope.toggleRightInfo = () => {
                scope.toggle = !scope.toggle;
                toggleSecondary = !toggleSecondary;
                this.$mdSidenav('rightInfo').toggle();
            }

            scope.desc = scope.$parent.desc;

            scope.messagePlaceholderUnselectedBlockType = this.$translate.instant("MESSAGE_PLACEHOLDER_UNSELECTED_BLOCK_TYPE");
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($mdSidenav, editorService, $translate, actions) => {
                return new MeevoBlockEditor($mdSidenav, editorService, $translate, actions);
            };

            directive.$inject = ["$mdSidenav", "BlockEditorService", "$translate", 'appointmentBookActionsService'];

            return directive;
        }

    }

    angular.module("ApptBookApp")
        .directive("meevoBlockEditor", MeevoBlockEditor.factory());
}